<template>
  <div id="top" class="nrs-privacy-policy-page">

    <div class="body-wrapper">
      <HeaderSimple />
      <TermsOfService lang="en-us"/>
      <FooterSimple />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderSimple from '@/components/HeaderSimple.vue';
import TermsOfService from '@/components/TermsOfService.vue';
import FooterSimple from '@/components/FooterSimple.vue';

export default {
  name: 'termsofservicepage',
  components: {
    HeaderSimple,
    TermsOfService,
    FooterSimple,
  },
};
</script>

<style lang="less" scoped>
*, :before, :after {
    box-sizing: border-box;
}

#top {
    margin: 0;
    padding: 0;
    font-size: 14px;
    line-height: 1.42857143;
    color: #3d3d3d;
    background-position-x: center;
    background-position-y: 75px;
    background-size: 1920px;
    background-repeat: no-repeat;
    background-image: url("../assets/background@2x.png");
    text-rendering: optimizeLegibility !important;
    -webkit-font-smoothing: antialiased !important;
    text-shadow: rgba(0,0,0,.01) 0 0 1px !important;
    font-family: 'Roboto', sans-serif !important;
}

.nrs-privacy-policy-page {
    text-align: justify;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}

.body-wrapper {
    min-height: 100%;
    margin-top: 0;
    position: relative;
}
</style>
